export const CHANGE = 'change';

export const DIALOG_RESPONSES = Object.freeze({
	CHANGE,
});
